enum BiteLogFlashEvent {
  SessionTokenInvalid = 1,
  SessionTokenExpired = 2,
}

export { BiteLogFlashEvent };
